import { RootState } from 'app/store';

export const selectHotspotLoading = (state: RootState) => state.hotspot.loading;
export const selectHotspotPublicData = (state: RootState) => state.hotspot.publicData;
export const selectHotspotPrivateData = (state: RootState) => state.hotspot.privateData;
export const selectHotspotError = (state: RootState) => state.hotspot.error;
